/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Geen_GymInputs */

const nl_planning_rooster_geen_gym = /** @type {(inputs: Planning_Rooster_Geen_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen gym`)
};

/**

* @param {Planning_Rooster_Geen_GymInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_geen_gym = /** @type {((inputs?: Planning_Rooster_Geen_GymInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Geen_GymInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_geen_gym(inputs)
});
export { planning_rooster_geen_gym as "planning.rooster.geen_gym" }